import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'fluxible-router';

// eslint-disable-next-line react/prop-types
const SectionItem = ({ section: { url, title }, isActive }) => (
  <li className={`nav-tab ${isActive ? 'active' : ''}`}>
    <NavLink href={url} activeClass="active">{title}</NavLink>
  </li>
);

const SectionsList = ({ sections, currentSection }) => (
  <ul className="navigation-bar-tabs nav nav-tabs">
    { sections && sections.map(section => (
      <SectionItem
        key={section.id}
        section={section}
        isActive={section.id === currentSection}
      />
    ))}
  </ul>
);

SectionsList.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  ).isRequired,
  currentSection: PropTypes.string.isRequired
};

export default SectionsList;
